import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {amCharts_v4_XY_template} from "./amCharts_v4_XY_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { TagTypeOption } from "../../utils/types/tag";
import * as am4core from "@amcharts/amcharts4/core";


declare var ko: any;
interface records {
    id: number,
    tag: string,
    tagType: string,
    averageOutputLast7Days: number,
    projectedActiveViewsMin: number,
    projectedActiveViewsMax: number,
    todaysOutputRecommendation: number,
    topicRecommendationToolTip: string,
    activeViewCount1DayAgo: number,
    activeViewCount2DayAgo: number,
    activeViewCount3DayAgo: number,
    chart: any
}

export class topic_recommendation_report_template extends vnTemplate{

    protected filterPreset: filterPreset_template;
    public tagFilter: filterAutocomplete_template;
    public tagTypeFilter: filterAutocomplete_template;
    protected simpleFilter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected activeViewsMaxTooltip: infoButton_template;
    protected activeViewsMaxTooltipContent;
    protected activeViewsMinTooltip: infoButton_template;
    protected activeViewsMinTooltipContent;

    protected getTemplateHtml(): string{
        return `
            <div id="list-references w-topic-recommendation">

                <div class="sub-header filter-preset w-justify ">
                        ` + this.filterPreset.getHtmlBuild() + `
                </div>

                <div class="sub-header w-justify">
                    <div class="w-left">

                        ${ this.tagFilter.getHtmlBuild() }

                        ${ this.tagTypeFilter.getHtmlBuild() }

                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">

                    <div id="selected-tags" data-bind="visible: tagsArray().length > 0">
                        <label class="small">Selected tags:</label>
                        <div class="form-group" data-bind="foreach: tagsArray">
                            <button class="btn-f-s icon i-x-after" type="button" data-bind=", text: name, event: { click: $parent.onClickDeleteTagArray }"></button>
                        </div>
                    </div>
                    <div id="selected-tagTypes" data-bind="visible: tagTypesArray().length > 0">
                        <label class="small">Selected tag types:</label>
                        <div class="form-group" data-bind="foreach: tagTypesArray">
                            <button class="btn-f-s icon i-x-after" type="button" data-bind="text: name, event: { click: $parent.onClickDeleteTagTypeArray }"></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div class="w-left">
                </div>
                <div class="w-center">
                    ${ this.simpleFilter.getHtmlBuild() }
                </div>
                <div class="w-right">
                    ${ this.pagination.getHtmlBuild() }
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results w-topic-reco">
                    ${  this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th class="topic-reco-info"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tag') }, css: { 'list-sort-desc': orderByAndDirection()=='tag_DESC', 'list-sort-asc': orderByAndDirection()=='tag_ASC' }">Tag Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'averageOutputLast7Days') }, css: { 'list-sort-desc': orderByAndDirection()=='averageOutputLast7Days_DESC', 'list-sort-asc': orderByAndDirection()=='averageOutputLast7Days_ASC' }">Last 7-Day<br/>Output Average</span></th>
                            <th><span class="icon list-sort-none" style="margin-left: 2.5rem;">Active Views Graph</span></th>
                            <th>
                                <div style="display: flex">
                                    <div class="w-tooltips-adv pos-bottom" style="margin-right: .5rem">
                                        ` + this.activeViewsMaxTooltip.getHtmlBuild() + `
                                    </div>
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'projectedActiveViewsMax') }, css: { 'list-sort-desc': orderByAndDirection()=='projectedActiveViewsMax_DESC', 'list-sort-asc': orderByAndDirection()=='projectedActiveViewsMax_ASC' }">Projected Active<br/>Views Max</span>
                                </div>
                            </th>
                            <th>
                                <div style="display: flex">
                                    <div class="w-tooltips-adv pos-bottom" style="margin-right: .5rem">
                                        ` + this.activeViewsMinTooltip.getHtmlBuild() + `
                                    </div>
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'projectedActiveViewsMin') }, css: { 'list-sort-desc': orderByAndDirection()=='projectedActiveViewsMin_DESC', 'list-sort-asc': orderByAndDirection()=='projectedActiveViewsMin_ASC' }">Projected Active<br/>Views Min</span>
                                </div>
                            </th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'todaysOutputRecommendation') }, css: { 'list-sort-desc': orderByAndDirection()=='todaysOutputRecommendation_DESC', 'list-sort-asc': orderByAndDirection()=='todaysOutputRecommendation_ASC' }">Today's Output<br/> Recommendation</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: records">
                        <tr class="topic-reco-main-row" >
                            <td class="topic-reco-info" rowspan="2">
                                <span class="topic-reco-title" data-bind="text: tag"></span>
                                <span class="topic-reco-tag" data-bind="text: tagType"></span>
                            </td>
                            <td rowspan="2"><span class="topic-reco-number output" data-bind="text: averageOutputLast7Days"></span></td>
                            <td rowspan="2" name="chartdiv"><span class="faux-span" data-bind="attr: { id : 'chartloading_' + $data.id }">Loading Chart..</span><div style="height: 100px" data-bind="template: { name: 'amCharts_v4_XY_template', data: chart.getTemplateViewModel() }"></div></td>
                            <td><span class="topic-reco-number potential" data-bind="text: Number(projectedActiveViewsMax).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span class="topic-reco-number potential" data-bind="text: Number(projectedActiveViewsMin).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span class="topic-reco-number recommendation icon i-tooltips-reco" data-bind="text: todaysOutputRecommendation, event: { click: $parent.onClickToggleTooltip($data.id)}"></span></td>
                        </tr>
                        <tr class="w-topic-popup" style="border-bottom: 1px solid #EAEAEA;">
                            <td colspan="3">
                                <div data-bind="attr: { id: 'tooltip-div-' + $data.id }" class="topic-popup">
                                    <button type="button" class="close-button icon i-x-after" data-bind="event: { click: $parent.onClickToggleTooltip.bind($parent, $data.id) }"></button>
                                    <div class="topic-popup-content" data-bind="html: topicRecommendationToolTip">
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial(): void{

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('topic-recommendation');

        this.tagFilter = new filterAutocomplete_template("filterAutocomplete_tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.setPlaceholder( 'Tag' );

        this.tagTypeFilter = new filterAutocomplete_template("filterAutocomplete_tagTypeFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter.setPlaceholder( 'Tag Type' );

        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.activeViewsMaxTooltip = new infoButton_template('activeViewsMaxTooltip', this.getTemplateViewModel(), this.caller)
        this.activeViewsMaxTooltip.setTitle('Projected Active Views Max Tooltip');
        this.activeViewsMaxTooltipContent = `<p>This calculated based on the most recent days of <strong>Active Views</strong> on the topic.  Views are considered <strong>Active</strong> if when they occur on an article that is <strong>less than 30 days</strong> old.</p><p>The potential is normalized for fluctuations between days of the week (e.g. Sundays being generally stronger than Wednesdays).</p><p>The <strong>closer</strong> the minimum and maximum are, the <strong>higher confidence</strong> can be had towards actioning on the recommendation.</p>`;
        this.activeViewsMaxTooltip.setContent(this.activeViewsMaxTooltipContent);

        this.activeViewsMinTooltip = new infoButton_template('activeViewsMinTooltip', this.getTemplateViewModel(), this.caller)
        this.activeViewsMinTooltip.setTitle('Projected Active Views Min Tooltip');
        this.activeViewsMinTooltipContent = `<p>This calculated based on the most recent days of <strong>Active Views</strong> on the topic.  Views are considered <strong>Active</strong> if when they occur on an article that is <strong>less than 30 days</strong> old.</p><p>The potential is normalized for fluctuations between days of the week (e.g. Sundays being generally stronger than Wednesdays).</p><p>The <strong>closer</strong> the minimum and maximum are, the <strong>higher confidence</strong> can be had towards actioning on the recommendation.</p>`;
        this.activeViewsMinTooltip.setContent(this.activeViewsMinTooltipContent);

        let body = document.body;
        if(body){
            body.classList.add('is-emaki-lab');
        }
    }

    protected getTemplateName(): string{
        return "topic-recommendation-report-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return{
            orderBy: ko.observable("projectedActiveViewsMax"),
            orderByDirection: ko.observable("DESC"),
            records: ko.observableArray([]),
            orderByAndDirection: ko.observable("projectedActiveViewsMax_DESC"),
            tagsArray: ko.observableArray([]),
            tagTypesArray: ko.observableArray([]),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickDeleteTagArray: function (data, event) {
                self.onClickDeleteTagArray(data);
            },
            onClickDeleteTagTypeArray: function (data, event) {
                self.onClickDeleteTagTypeArray(data);
            },
            onClickToggleTooltip: function (id) {
                self.onClickToggleTooltip(id);
            },
        };
    }

    public getViewModelForRequest(){

        let idTags = [];
        let tags = this.getTemplateViewModel().tagsArray();
        tags.forEach(function (tag) {
            idTags.push(tag.id+"^^"+tag.name)
        });

        let idTagTypes = [];
        let tagTypes = this.getTemplateViewModel().tagTypesArray();
        tagTypes.forEach(function (tagType) {
            idTagTypes.push(tagType.id+"^^"+tagType.name)
        });


        return {
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'topic-recommendation',
            filters: {
                tagsArray: idTags,
                tagTypesArray: idTagTypes,
                keyword: this.getTemplateViewModel().simpleFilter.filterKeyword,
                orderBy: this.getTemplateViewModel().orderBy(),
                orderByDirection: this.getTemplateViewModel().orderByDirection(),
            },
        };
    }

    public setRecords(records: Array<records>): void {
        this.getTemplateViewModel().records(records);
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);

        let records = this.getTemplateViewModel().records();

        let obj = this;

        setTimeout(function() {
            for(let record of records){
                obj.drawRecordChart(record);
            }
        }, 100);
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.tagsListReorder();
    }

    public initRecordChart(obj) {
        am4core.disposeAllCharts();
        am4core.unuseAllThemes();
        am4core.options.autoDispose = true;
        if (obj.hasOwnProperty('activeViewCount1DaysAgo') && obj['projectedActiveViewsMin']) {
            obj['chart'] = new amCharts_v4_XY_template(obj['id'], this.getTemplateViewModel(), this.caller);
        }

        return obj;
    }

    public drawRecordChart(obj){
        if (obj.hasOwnProperty('activeViewCount1DaysAgo') && obj['projectedActiveViewsMin']) {
            let today = new Date();

            let dates = [];
            for (let i = 0; i < 4; i++) {
                let date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);
                let formattedDate = date.toISOString().substring(0, 10);
                dates.push(formattedDate);
            }

            let chartData = [
                {
                    "date": dates[3],
                    "value": obj['activeViewCount3DaysAgo']
                },{
                    "date": dates[2],
                    "value": obj['activeViewCount2DaysAgo']
                },{
                    "date": dates[1],
                    "value": obj['activeViewCount1DaysAgo'],
                    "value2": obj['activeViewCount1DaysAgo'],
                    "value3": obj['activeViewCount1DaysAgo'],
                },{
                    "date": dates[0],
                    "value2": obj['projectedActiveViewsMin']
                },{
                    "date": dates[0],
                    "value3": obj['projectedActiveViewsMax']
                }
            ];
            obj['chart'].drawChart(chartData);
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    protected onClickDeleteTagArray(data) {
        let selectedTagArray = this.getTemplateViewModel().tagsArray();
        let index = selectedTagArray.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedTagArray.splice(index, 1);
        }

        this.getTemplateViewModel().tagsArray(selectedTagArray);
        this.caller.filterSimpleOnChange();
    }

    protected onClickDeleteTagTypeArray(data) {
        let selectedTagTypeArray = this.getTemplateViewModel().tagTypesArray();
        let index = selectedTagTypeArray.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedTagTypeArray.splice(index, 1);
        }

        this.getTemplateViewModel().tagTypesArray(selectedTagTypeArray);
        this.caller.filterSimpleOnChange();
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // tag filter
            if(urlParams.tagsArray) {
                interface Tag {
                    id: number;
                    name: string;
                }

                let selectedTags: Tag[] = urlParams.tagsArray.map((tag: string) => {
                    let [id, name] = tag.split('^^');
                    return { id: parseInt(id), name };
                });
                this.getTemplateViewModel().tagsArray(selectedTags);
            }

            // tag type filter
            if(urlParams.tagTypesArray) {
                let selectedTagTypes: TagTypeOption[] = urlParams.tagTypesArray.map((tagType: string) => {
                    let [id, name] = tagType.split('^^');
                    return { id: parseInt(id), name };
                });
                this.getTemplateViewModel().tagTypesArray(selectedTagTypes);
            }

            if(urlParams.keyword) {
                this.getTemplateViewModel().simpleFilter.filterKeyword(urlParams.keyword);
            }

            if(urlParams.orderBy){
                this.getTemplateViewModel().orderBy(urlParams.orderBy);
                let orderByParts = this.getTemplateViewModel().orderByAndDirection().split('_');
                orderByParts[0] = urlParams.orderBy;
                this.getTemplateViewModel().orderByAndDirection(orderByParts.join('_'));
            }

            if(urlParams.orderByDirection){
                this.getTemplateViewModel().orderByDirection(urlParams.orderByDirection);
                let orderByParts = this.getTemplateViewModel().orderByAndDirection().split('_');
                orderByParts[1] = urlParams.orderByDirection;
                this.getTemplateViewModel().orderByAndDirection(orderByParts.join('_'));
            }
        }
    }

    public onClickToggleTooltip(id) {
        const tooltipId = 'tooltip-div-' + id;
        const tooltipElement = document.getElementById(tooltipId);

        if (!tooltipElement) {
            return;
        }

        if (this.isTooltipOpen(id)) {
            tooltipElement.classList.remove('is-open');
        } else {
            const openTooltips = document.getElementsByClassName('is-open');
            for (let i = 0; i < openTooltips.length; i++) {
                openTooltips[i].classList.remove('is-open');
            }

            tooltipElement.classList.add('is-open');
        }
    }

    public isTooltipOpen(id) {
        let tooltipId = 'tooltip-div-' + id;
        let tooltipElement = document.getElementById(tooltipId);
        return tooltipElement && tooltipElement.classList.contains('is-open');
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/topic_recommendation_report_template.ts